import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AtokuStation } from '../../../models/atoku-station.model';

export interface EditStationDialogData {
    station: AtokuStation;
    categories: string[];
}

@Component({
    selector: 'app-edit-station-dialog',
    templateUrl: './edit-station-dialog.component.html',
    styleUrls: ['./edit-station-dialog.component.scss']
})
export class EditStationDialogComponent implements OnInit {
    form: FormGroup;
    categories: string[] = [];

    constructor(
        public dialogRef: MatDialogRef<EditStationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EditStationDialogData,
        private fb: FormBuilder
    ) {
        this.categories = data.categories ?? [];
        this.form = this.fb.group({
            id: [data.station.id],
            name: [data.station.name, Validators.required],
            category: [data.station.category, Validators.required]
        });
    }

    ngOnInit(): void {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.form.valid) {
            this.dialogRef.close(this.form.value);
        }
    }
}
